import { HTMLAttributes } from 'react'
import { useRouter } from 'next/router'

import Typography from '@/components/base/typography'
import { useLocaleStore } from '@/store/locale'
import { sanitizeAdsLink } from '@/utils/path'

import { cn } from '@/lib/utils'

type LanguageListProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    onClose: () => void
    className: string
  }>

const LanguageList: React.FC<LanguageListProps> = ({}) => {
  const [currentLocale, currentTranslations] = useLocaleStore((state) => [
    state.currentLocale,
    state.currentTranslations
  ])
  const { locales } = useRouter()

  return (
    <>
      {locales
        ?.filter((locale) => locale !== currentLocale)
        .map((lang: string, index: number) => (
          <div key={`lang-item-${index}`}>
            <a
              href={sanitizeAdsLink(
                currentTranslations?.find((t: { locale: string }) =>
                  t.locale.includes(lang)
                )?.href || `/${lang}`
              )}
              className={cn(
                '-m-[1rem] flex p-[1rem]',
                lang === currentLocale && 'link pointer-events-none'
              )}
            >
              <Typography
                className={cn('text-[1rem] font-bold uppercase text-white')}
              >
                {lang.toUpperCase()}
              </Typography>
            </a>
          </div>
        ))}
    </>
  )
}

export default LanguageList
